import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FixedSizeList as List } from 'react-window';
import Select from '@lwt-helix/select';
import { areaSelectDropdown } from '../../constants/suggestedAgents';

const MenuList = ({ children }) => {
    const listRef = useRef(null);
    const items = Array.isArray(children) ? children : [children];
    const focusedIndex = items.findIndex(item => item.props?.isFocused);

    useEffect(() => {
        if (focusedIndex >= 0) {
            listRef.current?.scrollToItem(focusedIndex);
        }
    }, [focusedIndex]);

    return (
        <List
            ref={listRef}
            height={Math.min(areaSelectDropdown.maxMenuHeight, items.length * areaSelectDropdown.itemHeight)}
            itemCount={items.length}
            itemSize={areaSelectDropdown.itemHeight}
            initialScrollOffset={Math.max(0, focusedIndex) * areaSelectDropdown.itemHeight}
        >
            {({ index, style }) => <div style={style}>{items[index]}</div>}
        </List>
    );
};

MenuList.propTypes = {
    children: PropTypes.node,
};

const AreaSelectDropdown = ({ value, onChange, options, dataLwtId, onMenuOpen, isDisabled }) => (
    <Select
        dataLwtId={dataLwtId}
        value={value}
        onChange={onChange}
        options={options}
        components={{ MenuList }}
        isClearable={false}
        isDisabled={isDisabled}
        onMenuOpen={onMenuOpen}
    />
);

AreaSelectDropdown.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    dataLwtId: PropTypes.string,
    onMenuOpen: PropTypes.func,
    isDisabled: PropTypes.bool,
};

export default AreaSelectDropdown;
